function randomstring(L: number) {
    var s = '';
    var randomchar = function() {
      var n = Math.floor(Math.random() * 62);
      if (n < 10) return n; //1-10
      if (n < 36) return String.fromCharCode(n + 55); //A-Z
      return String.fromCharCode(n + 61); //a-z
    }
    while (s.length < L) s += randomchar();
    return s;
  }

function isPageReloaded(){
  const performanceNavigation =window.performance.getEntries()[0] as PerformanceNavigationTiming
  console.info("[ADPClient] performanceNavigationType",performanceNavigation.type);
  if (performanceNavigation) {
    if(performanceNavigation.type=== "reload")
    return true;
    else return false;
 
  }
  else {
    return false;
  }
}  
function getDomain(){
  const location =window.location.origin;
  const domain = location.includes('localhost') ? "http://localhost:3001" : `${location}/adp-chrome-app`;
  return domain;
}
function getApiDomain(){
  const hostname =window.location.hostname;
  const protocol = window.location.protocol
  const domain = hostname.includes('localhost') ? `${protocol}//api.enaep.dev24.npdng.org` : `${protocol}//api.${hostname}`;
  return domain;
}

const environment={
  resovleAppDomain: getDomain,
  resolveApiDomain: getApiDomain
}

function sleep(ms:number) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export {randomstring,isPageReloaded,environment,sleep};